import { Button, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { useController, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { buttonStyle } from '../../TransitionStyles';

FormButtonOptionsInput.propTypes = {
  fieldAttributes: PropTypes.object,
  fieldName: PropTypes.string,
  isMultiSelect: PropTypes.bool,
  trailingOption: PropTypes.node,
};

export default function FormButtonOptionsInput({
  fieldAttributes,
  fieldName,
  isMultiSelect = false,
  trailingOption = null,
}) {
  const { control } = useFormContext();
  const { field } = useController({ name: fieldName, control });
  const isCanceled = useSelector((state) => state.transitions?.data?.isCanceled);
  const selectedValues = Array.isArray(field.value) ? field.value : [];

  const isSelected = (optionValue) =>
    isMultiSelect
      ? selectedValues.some((selected) => String(selected) === String(optionValue))
      : String(field.value) === String(optionValue);

  const onOptionClick = (optionValue) => {
    if (!isMultiSelect) {
      field.onChange(isSelected(optionValue) ? null : optionValue);
      return;
    }

    const exists = selectedValues.some((selected) => String(selected) === String(optionValue));
    field.onChange(
      exists
        ? selectedValues.filter((selected) => String(selected) !== String(optionValue))
        : [...selectedValues, optionValue]
    );
  };

  return (
    <Grid container spacing={1}>
      {fieldAttributes.options.map((option) => (
        <Grid item key={option.value}>
          <Button
            disabled={!fieldAttributes.isEditable || isCanceled}
            variant={isSelected(option.value) ? 'contained' : 'outlined'}
            onClick={() => onOptionClick(option.value)}
            sx={{ ...buttonStyle, mt: 1 }}
          >
            {option.label}
          </Button>
        </Grid>
      ))}
      {trailingOption && <Grid item>{trailingOption}</Grid>}
    </Grid>
  );
}
